import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export const MovieFilterIcon = React.forwardRef<HTMLSpanElement, IconProps>((props, ref) => {
    return <Icon {...props} iconKey={"movie_filter"} ref={ref}/>
});

MovieFilterIcon.displayName = "MovieFilterIcon";
